<template>
  <div class="block-content">
    <div
      v-if="!show"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div
      v-if="show"
      class="box"
    >
      <top-section
        :logo="game.venueInformation.logo"
        :notes="game.venueInformation.notes"
        :session-times="game.sessionTimes"
      />
    </div>

    <div
      v-if="show"
      class="columns"
    >
      <details-component :game="game" />
      <div class="column is-6 is-paddingless-touch">
        <top-ten
          :game="game"
          :selected-month="selectedMonth"
          @setMonth="setMonth"
        />
        <tournaments
          :game="game"
          :selected-month="selectedMonth"
          @setMonth="setMonth"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import TopSection from './TopSection.vue'
  import DetailsComponent from './Details.vue'
  import TopTen from './TopTen.vue'
  import Tournaments from './Tournaments.vue'
  export default {
    name: 'VenueDetails',
    components: {
      TopSection,
      DetailsComponent,
      TopTen,
      Tournaments
    },
    props: ['user', 'token'],
    data () {
      return {
        game: '',
        show: false,
        selectedMonth: '',
        searchMonth: 0,
        numberOfPlayers: 10
      }
    },
    mounted () {
      this.selectedMonth = this.getCurrentMonth()
      this.getGame(true)
    },
    methods: {
      getGame (initial) {
        let id = this.$route.params.id
        let url
        if (initial) {
          url = `general/venue/${id}/0/${this.numberOfPlayers}`
        } else url = `general/venue/${id}/${this.searchMonth}/${this.numberOfPlayers}`
        this.$axios({
          method: 'POST',
          url,
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.show = true
            this.game = res.data
          })
          .catch((error) => {
            console.log(error)
          })
      },
      getCurrentMonth () {
        let date = new Date()
        return date.getMonth()
      },
      setMonth (number, numberOfPlayers) {
        this.searchMonth = number
        this.selectedMonth = this.getCurrentMonth() + +number
        this.numberOfPlayers = numberOfPlayers
        this.getGame(false)
      },
      getMonth (number) {
        // Number is month 0 - Jan, 1 - Feb, etc. If current month is Nov or Dec turn to Jun and Feb
        if (number === 12) number = 0
        if (number === 13) number = 1
        if (number === -1) number = 11
        if (number === -2) number = 10
        if (number === -3) number = 9
        switch (number) {
          case 0:
            return 'January'
          case 1:
            return 'February'
          case 2:
            return 'March'
          case 3:
            return 'April'
          case 4:
            return 'May'
          case 5:
            return 'June'
          case 6:
            return 'July'
          case 7:
            return 'August'
          case 8:
            return 'September'
          case 9:
            return 'October'
          case 10:
            return 'November'
          case 11:
            return 'December'
          default:
            return 'Error'
        }
      }
    }
  }
</script>